import { ImageLoaderProps } from 'next/image';
import { MediaResizerRoute } from '../entities/MediaResizerRoute';

const defaultQualityPercent = 75;
const resizableExtensions = /\.(png|jpe?g|webp)$/i;

export const getMediaResizerUrl = (
  { src, width, quality = defaultQualityPercent }: ImageLoaderProps,
  routes: MediaResizerRoute[],
): string | null => {
  const route = routes.find(({ sourceOrigins }) =>
    sourceOrigins.some((origin) => src.startsWith(`${origin}/`)),
  );

  if (!route) return null;

  const { pathname, search } = new URL(src);

  if (search || !resizableExtensions.test(pathname)) return null;

  const resizerUrl = `${route.resizerOrigin}${pathname}?width=${width}&quality=${quality}`;

  return resizerUrl;
};
